import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useCurrencyFormatter } from '@/hooks/useCurrencyFormatter';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly label: string;
  readonly amount: number | null;
  readonly currency: string;
}

export const LabeledAmount: React.FC<Props> = (props: Props): React.ReactElement => {
  const { label, amount, currency } = props;
  const tr = useTranslator();

  const formatter = useCurrencyFormatter();
  const formattedAmount = React.useMemo(
    (): string => (amount === null ? '' : formatter.format(amount, currency)),
    [amount, currency, formatter],
  );

  return (
    <Box sx={styles.container}>
      <Typography variant="body2" fontWeight={500}>
        {tr(label)}
      </Typography>
      <Box>
        <Typography component="span" variant="body2" fontWeight={500} color="text.primary">
          {formattedAmount}
        </Typography>
      </Box>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 24,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: 'custom.DividerLight',
    py: 5,
  },
};
